import React, { PureComponent } from 'react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { NotificationImportant } from '@mui/icons-material';
import { green, red, orange } from '@mui/material/colors';
import Grid from '@mui/material/Grid';

import { GenTooltipIcon } from '../utils/IconsDisplay';

export default class ChronoLitiges extends PureComponent {
  state = {
    prevTimer: this.props.timer,
    colorTimer: '',
    textTimer: '',
    chrono: 0
  }

  count = 0;

  componentDidUpdate(prevProps) {
    if (this.props.timer !== prevProps.timer) {
      clearInterval(this.count);
      this.count = setInterval(this.addWeekDaysToTimer, 1000);
    }
  }

  componentDidMount() {
    this.count = setInterval(this.addWeekDaysToTimer, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.count);
  }

  colorTimer() {
    const chrono = this.state.chrono;
    if (chrono > 48) {
      return this.setState({
        colorTimer: red,
        textTimer: 'Sous 24h',
      });
    } else if ((chrono >= 24) && (chrono <= 48)) {
      return this.setState({
        colorTimer: orange,
        textTimer: '24h à 48h',
      });
    }
    return this.setState({
      colorTimer: green,
      textTimer: '+48h',
    });
  }

  addWeekDaysToTimer = () => {
    const weekDay = [];
    const initialIsoWeekDay = dayjs(this.props.timer).isoWeekday();
    const initialDate = dayjs(this.props.timer).format('HH');
    for (let m = dayjs(this.props.timer);
      m.isBefore(dayjs());
      m.add(1, 'day')) {
      let date;
      const dayjsIsoWeekDay = dayjs(m.format('YYYY-MM-DD')).isoWeekday();
      const dayjsDate = dayjs(m, 'YYYY-MM-DD-HH-mm').format('HH');

      if ((dayjsIsoWeekDay !== 6 && dayjsIsoWeekDay !== 7)
      || (initialIsoWeekDay === 5 && initialDate > 17)) {
        if ((initialIsoWeekDay !== 5 && dayjsIsoWeekDay === 5)
        || (initialIsoWeekDay === 5 && dayjsDate > 17)) {
          date = dayjs(m, 'YYYY-MM-DD-HH-mm').hour(17).minute(0).second(0);
        } else if ((initialIsoWeekDay !== 1 && dayjsIsoWeekDay === 1)
        || (initialIsoWeekDay === 1 && dayjsDate < 9)) {
          date = dayjs(m, 'YYYY-MM-DD-HH-mm').hour(9).minute(0).second(0);
        } else {
          date = dayjs(m, 'YYYY-MM-DD-HH-mm');
        }
        weekDay.push({
          date,
          isoWeekday: dayjs(m.format('YYYY-MM-DD')).isoWeekday()
        });
      }
    }

    let hours;
    const chrono = weekDay.reduce((acc, curr, indice) => {
      if (indice !== (weekDay.length - 1)) {
        if (curr.isoWeekday === 5) {
          hours = Math.abs(dayjs(weekDay[indice].date)
            .diff(dayjs(weekDay[indice].date.hour(17)), 'hour'));
        } else {
          hours = dayjs(weekDay[indice + 1].date)
            .diff(dayjs(weekDay[indice].date), 'hour');
        }
      } else if (curr.isoWeekday === 5) {
        hours = dayjs().diff(dayjs(weekDay[indice].date), 'hour') - 64;
      } else {
        hours = dayjs().diff(dayjs(weekDay[indice].date), 'hour');
      }
      return acc + hours;
    }, 0);
    return this.setState({
      chrono
    }, this.colorTimer);
  }

  render() {
    const { style, timer } = this.props;
    const { colorTimer, textTimer } = this.state;

    return ( <div style={style}>
      {timer &&
      <Grid container xs={12} wrap='nowrap' alignItems='center' >
        <Grid item={5}>
          <GenTooltipIcon
            Icon={NotificationImportant}
            text={textTimer}
            color={colorTimer}
          />
        </Grid>
      </Grid>}
    </div>);
  }
}
